var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.828 3.18069C10.4086 1.16217 8.33183 0 6.14442 0C5.05071 0 3.98773 0.289154 3.01691 0.828536C2.04609 1.37348 1.17358 2.16865 0.460831 3.18069C-0.15361 4.05372 -0.15361 5.47168 0.460831 6.3447C1.88019 8.36878 3.957 9.52539 6.14442 9.52539C7.23812 9.52539 8.30111 9.23624 9.27192 8.69685C10.2427 8.15191 11.1152 7.35674 11.828 6.3447C12.4424 5.47724 12.4424 4.05372 11.828 3.18069ZM6.14442 7.01198C4.76807 7.01198 3.66207 6.0055 3.66207 4.76548C3.66207 3.52545 4.76807 2.51897 6.14442 2.51897C7.52076 2.51897 8.62676 3.52545 8.62676 4.76548C8.62676 6.0055 7.52076 7.01198 6.14442 7.01198Z",
    fill: "#484964"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14322 3.17554C5.17855 3.17554 4.39209 3.88729 4.39209 4.76587C4.39209 5.63889 5.17855 6.35065 6.14322 6.35065C7.1079 6.35065 7.90053 5.63889 7.90053 4.76587C7.90053 3.89285 7.1079 3.17554 6.14322 3.17554Z",
    fill: "#484964"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.630ddb71fddfab856e51df9961ec7f39.svg";
export { ForwardRef as ReactComponent };